import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GtmService {

  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  pushEvent(event: string, data?: Record<string, any>): void {
    if (!isPlatformBrowser(this.platformId) || !environment.production) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  }
}
